import {IntermediatePart} from "../../intermediatePart";

export default class RightIsland extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_right_island';
    this.partName = 'Right Island';
    this.translateId = "visualizer.kitchen.center_island.center_island_right_island";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new RightIsland());
  }
}
